<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="addUsager" :validation-schema="usagerSchema">
        <!-- Début - Boutons radio en haut -->
        <div class="row mb-10">
          <div class="col-12 d-flex justify-content-end">
            <div class="form-group radio-group-right">
              <div class="d-flex align-items-center gap-15">
                <div class="form-check">
                  <Field name="statutUsager" type="radio" value="Personne physique" id="personne-physique"
                    class="form-check-input" v-model="typeDefault" />
                  <label class="form-check-label" for="personne-physique">
                    Personne physique
                  </label>
                </div>
                <div class="form-check">
                  <Field name="statutUsager" type="radio" value="Personne morale" id="personne-morale"
                    class="form-check-input" v-model="typeDefault" />
                  <label class="form-check-label" for="personne-morale">
                    Personne morale
                  </label>
                </div>
              </div>
              <ErrorMessage name="statutUsager" class="text-danger" />
            </div>
          </div>
        </div>
        <!-- Fin - Boutons radio en haut -->
        <div class="row">
          <!-- Colonne image (uniquement pour Personne physique) -->
          <div class="col-md-3 col-sm-12 col-xm-12 col-xl-3 col-lg-3" v-if="showType">
            <div class="upload-container">
              <input type="file" name="urlImage" ref="fileInput" @change="(event) => onFilePrinChange(event)"
                accept="image/*" hidden />
              <div class="preview-card" @click="triggerFileInput">
                <img v-if="imagePreview" :src="imagePreview" alt="Image preview" />
                <div v-else class="text-center">
                  <div>
                    <i class="flaticon-camera fs-1"></i>
                  </div>
                  Cliquez pour ajouter l'image
                </div>
                <button v-if="imagePreview" class="delete-btn" @click.stop="removeImage">
                  <i class="flaticon-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="col-md-9 col-sm-12 col-xm-12 col-xl-9 col-lg-9">
            <!-- Personne Physique - Tous les champs -->
            <div class="row">
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6">
                <div class="form-group mb-5 mb-sm-10 mb-md-10">
                  <label class="d-block text-black fw-semibold mb-10" v-if="showType">
                    Nom <span class="text-danger">*</span>
                  </label>
                  <label class="d-block text-black fw-semibold mb-10" v-else>
                    Nom Gérant <span class="text-danger">*</span>
                  </label>
                  <Field name="nom" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le nom" />
                  <ErrorMessage name="nom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6">
                <div class="form-group mb-5 mb-sm-10 mb-md-10">
                  <label class="d-block text-black fw-semibold mb-10" v-if="showType">
                    Prénom <span class="text-danger">*</span>
                  </label>
                  <label class="d-block text-black fw-semibold mb-10" v-else>
                    Prénom Gérant <span class="text-danger">*</span>
                  </label>
                  <Field name="prenom" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer le prenom" />
                  <ErrorMessage name="prenom" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="showType">
                <div class="form-group mb-5 mb-sm-10 mb-md-10">
                  <label class="d-block text-black fw-semibold mb-10">
                    Adresse
                  </label>
                  <Field name="adresse" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer l'adresse" />
                  <ErrorMessage name="adresse" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="showType">
                <div class="form-group mb-sm-10 mb-md-10">
                  <label class="d-block text-black fw-semibold mb-10">
                    Email 
                  </label>
                  <Field name="email" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer l'email" />
                  <ErrorMessage name="email" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-if="showType">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold mb-10">
                    Téléphone
                  </label>
                  <Field name="numtel" v-model="telephone" v-slot="{ field }">
                    <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field"
                      defaultCountry="BJ" mode="international" @validate="validate"
                      class="shadow-none fs-md-15 text-black py-2">
                    </vue-tel-input>
                  </Field>
                  <ErrorMessage name="numtel" class="text-danger" />
                  <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correcte</div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6" v-show="showType">
                <div class="form-group mb-sm-10 mb-md-10">
                  <label class="d-block text-black fw-semibold mb-10">
                    Date de naissance
                  </label>
                  <Field name="dateNais" type="date" class="form-control shadow-none fs-md-15 text-black" />
                  <ErrorMessage name="dateNais" class="text-danger" />
                </div>
              </div>
            </div>
          </div>

          <!-- Personne morale - Tous les champs -->
          <div class="row" >
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6 mb-2" v-if="showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  IFU 
                </label>
                <Field name="ifu" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer un ifu" />
                <ErrorMessage name="ifu" class="text-danger" />
              </div>
            </div>
            <div class="col-md-6 col-sm-12 col-xm-12 col-xl-6 col-lg-6 mb-2" v-if="showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  NPI
                </label>
                <Field name="npi" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer un npi" />
                <ErrorMessage name="npi" class="text-danger" />
              </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xm-12 col-xl-12 col-lg-12 mb-2" v-show="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Raison sociale <span class="text-danger">*</span>
                </label>
                <Field name="raisonSocial" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer la raison sociale" />
                <ErrorMessage name="raisonSocial" class="text-danger" />
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xm-4 col-xl-4 col-lg-4" v-show="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Sigle
                </label>
                <Field name="sigle" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer le sigle" />
                <ErrorMessage name="sigle" class="text-danger" />
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xm-4 col-xl-4 col-lg-4 mb-2" v-if="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  IFU
                </label>
                <Field name="ifu" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer un ifu" />
                <ErrorMessage name="ifu" class="text-danger" />
              </div>
            </div>
            <div class="col-md-4 col-sm-12 col-xm-12 col-xl-4 col-lg-4" v-show="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Régistre de commerce <span class="text-danger">*</span>
                </label>
                <Field name="rccm" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer le régistre de commerce" />
                <ErrorMessage name="rccm" class="text-danger" />
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xm-4 col-xl-4 col-lg-4" v-if="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  NPI
                </label>
                <Field name="npi" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer un npi" />
                <ErrorMessage name="npi" class="text-danger" />
              </div>
            </div>
            <div class="col-md-8 col-sm-8 col-xm-8 col-xl-8 col-lg-8 mb-2" v-if="!showType">
              <div class="form-group mb-5 mb-sm-10 mb-md-10">
                <label class="d-block text-black fw-semibold mb-10">
                  Adresse
                </label>
                <Field name="adresse" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer l'adresse" />
                <ErrorMessage name="adresse" class="text-danger" />
              </div>
            </div>
            <div class="col-md-4 col-sm-12 col-xm-12 col-xl-4 col-lg-4" v-if="!showType">
              <div class="form-group mb-sm-10 mb-md-10">
                <label class="d-block text-black fw-semibold mb-10">
                  Email
                </label>
                <Field name="email" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer l'email" />
                <ErrorMessage name="email" class="text-danger" />
              </div>
            </div>
            <div class="col-md-4 col-sm-12 col-xm-12 col-xl-4 col-lg-4" v-if="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Téléphone
                </label>
                <Field name="numtel" v-model="telephone" v-slot="{ field }">
                  <vue-tel-input placeholder="Entrer le numéro de téléphone" v-model="field.value" v-bind="field"
                    defaultCountry="BJ" mode="international" @validate="validate"
                    class="shadow-none fs-md-15 text-black py-2">
                  </vue-tel-input>
                </Field>
                <ErrorMessage name="numtel" class="text-danger" />
                <div v-if="!validPhone" class="text-danger">Veuillez entrer un numéro correcte</div>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 col-xm-12 col-xl-4 col-lg-4" v-show="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Date de création
                </label>
                <Field name="dateCreation" type="date" class="form-control shadow-none fs-md-15 text-black" />
                <ErrorMessage name="dateCreation" class="text-danger" />
              </div>
            </div>
            <!-- <div class="col-md-12 col-sm-12 col-xm-12 col-xl-12 col-lg-6" v-show="!showType">
              <div class="form-group">
                <label class="d-block text-black fw-semibold mb-10">
                  Régistre de commerce 
                </label>
                <Field name="rccm" type="text" class="form-control shadow-none fs-md-15 text-black"
                  placeholder="Entrer le régistre de commerce" />
                <ErrorMessage name="rccm" class="text-danger" />
              </div>
            </div> -->
          </div>
        </div>

        <!-- Zone de dépôt des fichiers (commune aux deux types) -->
        <div class="row mt-3">
          <div class="col-md-12">
            <div class="product-upload mb-10">
              <div class="dz-message needsclick">
                <DropZone name="fichiers[]" :maxFilesize="50000000" :maxFiles="Number(10000000000)" class=""
                  :uploadOnDrop="true" @addedFile="onFileAdd" @removedFile="onFileRemove" :options="dropzoneOptions"
                  @vdropzone-success="onSuccess" @vdropzone-error="onError">
                  <div class="default-image-container" v-if="!hasFiles">
                    <img :src="defaultImage" alt="Default" class="default-image" />
                    <p>Glissez et dépossez ici</p>
                  </div>
                </DropZone>
              </div>
            </div>
          </div>
          <div class="col-md-12 mt-1">
            <div class="d-flex align-items-center ">
              <button class="btn btn-success me-3" type="submit">
                Ajouter un marchand
              </button>
              <router-link to="/liste-usager" class=" btn btn-danger ">
                <i class="fa fa-trash-o lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler
              </router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, reactive, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import { error, success } from '@/utils/utils';
import { useRouter } from 'vue-router';
import axios from 'axios';
import DropZone from "dropzone-vue";
import { VueTelInput } from 'vue3-tel-input';
import 'vue3-tel-input/dist/vue3-tel-input.css';

export default defineComponent({
  name: "AddUsager",
  components: {
    Form,
    Field,
    ErrorMessage,
    VueTelInput,
    DropZone
  },
  setup() {
    const router = useRouter();
    const typeDefault = ref("Personne physique");
    const showType = ref(true);
    // Schéma de validation adapté
    const usagerSchema = Yup.object().shape({
      statutUsager: Yup.string().required('Le statut est obligatoire'),
      // Champs personne physique
      nom: Yup.string().when('statutUsager', {
        is: "Personne physique",
        then: schema => schema.required("Le nom est obligatoire"),
        otherwise: schema => schema.notRequired()
      }),
      prenom: Yup.string().when('statutUsager', {
        is: "Personne physique",
        then: schema => schema.required("Le prénom est obligatoire"),
        otherwise: schema => schema.notRequired()
      }),
      dateNais: Yup.date().when('statutUsager', {
        is: "Personne physique",
        then: schema => schema.notRequired(),
        otherwise: schema => schema.notRequired()
      }),
      // Champs personne morale
      raisonSocial: Yup.string().when('statutUsager', {
        is: "Personne morale",
        then: schema => schema.required("La raison sociale est obligatoire"),
        otherwise: schema => schema.notRequired()
      }),
      dateCreation: Yup.date().when('statutUsager', {
        is: "Personne morale",
        then: schema => schema.required("La date de création est obligatoire"),
        otherwise: schema => schema.notRequired()
      }),
      rccm: Yup.string().when('statutUsager', {
        is: "Personne morale",
        then: schema => schema.required("Le RCCM est obligatoire"),
        otherwise: schema => schema.notRequired()
      }),
      sigle: Yup.string().when('statutUsager', {
        is: "Personne morale",
        then: schema => schema.notRequired(),
        otherwise: schema => schema.notRequired()
      }),
      // npi: Yup.string().when('statutUsager', {
      //   is: "Personne physique",
      //   then: schema => schema.required("Le NPI est obligatoire"),
      //   otherwise: schema => schema.notRequired()
      // }),
      // Champs communs
      adresse: Yup.string().notRequired(),
      email: Yup.string().email("Veuillez entrer un mail valide").notRequired(),
      numtel: Yup.string().notRequired(),
      ifu: Yup.string()
        .matches(/^\d{13}$/, "IFU doit contenir exactement 13 chiffres.")
        .notRequired(),
      npi: Yup.string()
        .matches(/^\d{10}$/, "NPI doit contenir exactement 10 chiffres.")
        .notRequired(),
    });
    // Reste du script inchangé...
    const telephone = ref("");
    const validPhone = ref(false);
    const numberPhone = ref("");
    const check = ref(false);
    const fileInput = ref();
    const imagePreview = ref<string | null>(null);
    const numtel = ref("");

    // const imageFile = ref(null);
    const imageFile = ref<File | null>(null);
    const toutFichier = ref<Array<File>>([]);
    const hasFiles = ref(false);
    const defaultImage = "/public/welcome2.png";
    const validate = (phoneObject: any) => {
      validPhone.value = phoneObject.valid;
      if (phoneObject.valid) {
        telephone.value = phoneObject.number;
        numberPhone.value = phoneObject.nationalNumber;
      } else {
        telephone.value = "";
        numberPhone.value = "";
      }
    };
    const triggerFileInput = () => {
      fileInput.value.click();
    };
    const onFilePrinChange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      const file = target.files?.[0];
      if (file) {
        imageFile.value = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          imagePreview.value = e.target?.result as string;
        };
        reader.readAsDataURL(file);
      }
    };
    const removeImage = () => {
      imagePreview.value = null;
      imageFile.value = null;
    };
    const onFileAdd = (file: any) => {
      toutFichier.value.push(file.file);
      hasFiles.value = true;
    };
    const images = reactive([
      {
        file: null as File | null,
        previewUrl: null as string | null,
      },
    ]);


    const dropzoneOptions = {
      url: 'your-upload-url', // URL de téléchargement des fichiers
      thumbnailWidth: 150,
      maxFilesize: 50, // Taille maximale du fichier en Mo
      maxFiles: 10, // Nombre maximal de fichiers
      headers: { "My-Awesome-Header": "header value" },
      acceptedFiles: 'image/*',
    };
    const onSuccess = (file) => {
      console.log('Upload réussi:', file);
    };

    const onError = (file, message) => {
      console.error('Erreur de téléchargement:', message);
    };

    const onFileRemove = (file: any) => {
      const index = toutFichier.value.findIndex(f =>
        f.name === file.file.name && f.size === file.file.size
      );
      if (index !== -1) {
        toutFichier.value.splice(index, 1);
      }
      hasFiles.value = toutFichier.value.length > 0;
    };
    const addUsager = async (values, { resetForm }) => {

      // values.numtel = numtel.value;
      values['autreFichier[]'] = [];
      values['statutUsager'] = typeDefault.value;
      values["typeUsager"] = typeDefault.value;
      values["urlImage"] = [];
      if (toutFichier.value.length > 0) {
        values['autreFichier[]'] = toutFichier.value;
      }
      if (imageFile.value) {
        values["urlImage"] = imageFile.value;
      }

      axios.post("usagers", values, {
        headers: { "Content-Type": "multipart/form-data", Accept: "*/*" },
      })
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListeUsagerPage" });
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };


    const onFileChange = (event, index) => {
      const file = event.target.files[0];
      if (file) {
        images[index].previewUrl = URL.createObjectURL(file);
        images[index].file = file;
      }
    };

    watch(typeDefault, (newValue) => {
      if (newValue === "Personne physique") {
        typeDefault.value = "Personne physique";
        showType.value = true;
      } else {
        typeDefault.value = "Personne morale";
        showType.value = false;
      }
    });

    return {
      onFileChange,
      onSuccess,
      onError,
      images,
      usagerSchema,
      typeDefault,
      showType,
      telephone,
      validPhone,
      numberPhone,
      check,
      validate,
      fileInput,
      imagePreview,
      dropzoneOptions,
      imageFile,
      triggerFileInput,
      onFilePrinChange,
      removeImage,
      toutFichier,
      hasFiles,
      onFileAdd,
      onFileRemove,
      defaultImage,
      addUsager,
    };
  }
});
</script>

<style scoped>
/* Alignement des boutons radio à droite */
.radio-group-right {
  text-align: right;
  padding-right: 15px;
}

/* Ajustement responsive */
@media (max-width: 768px) {
  .radio-group-right {
    text-align: left;
    padding-right: 0;
  }
}

/* Transition fluide pour la colonne */
.col-md-3,
.col-md-9,
.col-md-12 {
  transition: all 0.3s ease;
}

.form-check {
  margin-right: 20px;
}

.form-check-input {
  margin-right: 5px;
}

.dropzone-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.default-image-container {
  text-align: center !important;
  margin: 20px 0 !important;
}

.default-image {
  width: 100px !important;
  height: auto !important;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}

@import 'dropzone-vue/dist/dropzone-vue.common.css';

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.preview-card {
  width: 100%;
  height: 240px;
  border: 2px dashed #4caf50;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  background: #f8f8f8;
  position: relative;
}

.preview-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: red;
  color: white;
  border: none;
  padding: 5px 8px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
}

.delete-btn:hover {
  background: darkred;
}
</style>